import { Text, Box, VStack, Button } from '@chakra-ui/react';

type Props = {
  isB2BUser: boolean | null;
};

/**
 * Component to display a message when a user does not have access to the classes tab.
 * @param {Props} { isB2BUser } - Decides to render message for B2B users or B2C users.
 * @returns {JSX.Element} - The component to display the message.
 */
export const ClassesAccessDeniedMessage = ({ isB2BUser }: Props): JSX.Element => {
  if (isB2BUser) {
    return (
      <Box px="20px" mt="60px">
        <VStack gap="20px">
          <VStack gap="10px" color="text.tertiary">
            <Text textStyle="body.s.medium">
              Diese Funktion ist exklusiv für Lehrende & Praxisanleitende in deiner Organisation.
            </Text>
            <Text textStyle="body.s.regular" color="text.secondary" lineHeight="1.3">
              Kontaktiere deinen Administrator, um den Zugriff für dich freizuschalten.
            </Text>
          </VStack>
        </VStack>
      </Box>
    );
  }
  return (
    <Box px="l" mt="60px">
      <VStack gap="l">
        <VStack gap="10px" color="text.secondary">
          <Text textStyle="body.s.medium">Diese Funktion ist exklusiv für Organisationen.</Text>
          <Text textStyle="body.s.regular" color="text.secondary" lineHeight="1.3">
            Kontaktiere unser Partnership-Team, um den Zugriff für deine Organisation
            freizuschalten.
          </Text>
        </VStack>
        <Button asChild variant="primary" minWidth="220px">
          <a href="mailto:contact@novaheal.de?subject=Novaheal Zugang für meine Schule">
            Kontakt aufnehmen
          </a>
        </Button>
      </VStack>
    </Box>
  );
};
